import EarningsCertificateModalModule from './earnings-certificate-modal.module'

export default EarningsCertificateModalModule
